import React from 'react'
import PropTypes from 'prop-types'

import pluralize from 'pluralize'

import * as styles from './styles'

const PaginationSummary = ({ itemName, items, pages }) => (
  <div style={styles.summary}>{`${items} ${pluralize(itemName, items)} found, ${pages} ${pluralize('pages', pages)}`}</div>
)

PaginationSummary.propTypes = {
  itemName: PropTypes.string.isRequired,
  items: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
}

export default PaginationSummary
